

export function UserFilters({ filter, filtered, list, setFilter }) {
  return (
    <>
      <div className="flex items-center gap-2 flex-wrap mb-4">
        {["Todos", "conselheiro", "diretor"].map((s) => (
          <button
            key={s}
            data-testid={`iu-filter-${s.toLowerCase()}`}
            onClick={() => setFilter(s)}
            className={`px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] border rounded-sm ${
              filter === s
                ? "bg-[#0A0F14] text-white border-[#0A0F14]"
                : "bg-white text-slate-700 border-slate-300 hover:border-[#002776]"
            }`}
          >
            {s === "Todos"
              ? "Todos"
              : s === "conselheiro"
              ? "Conselheiros"
              : "Diretores"}
          </button>
        ))}
        {list && (
          <span className="ml-auto text-[11px] uppercase tracking-[0.22em] text-slate-500">
            {filtered.length}{" "}
            {filtered.length === 1 ? "usuário" : "usuários"}
          </span>
        )}
      </div>

    </>
  );
}
